module.exports = __webpack_public_path__ + "img/restart.72116de4.svg";